import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

export default function AlertDialog(props) {
  const { validerroropen, setvaliderroropen, alertLabType } = props;

  const handleClose = async () => {
    setvaliderroropen(false);
    const alertValue = {
      labtype: alertLabType,
      lab_id: localStorage.getItem("InstanceID"),
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/updatetrainerpopupmessagestatus/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(alertValue),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Successfully updated:", data);
    } catch (error) {
      console.error("Error updating alert status:", error);
    }
  };

  
  return (
    <Dialog
      open={validerroropen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <WarningRoundedIcon style={{ color: "tomato" }} />{" "}
        <span style={{ fontSize: "18px" }}>Things to Keep in Mind</span>
      </DialogTitle>
  
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component="div">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>To maintain a secure and stable lab environment, strictly avoid the following activities on the lab server(s):</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>❌ Changing user/root passwords</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>❌ Changing the machine's IP address</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>❌ Changing authentication mechanisms (e.g., configuring external AD/LDAP)</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>❌ Deleting or modifying OS/system files</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>❌ Network scanning, sniffing, or tampering</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>❌ Using the lab for any illegal or unauthorized activities</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>⚠ These actions may cause the lab server to become unavailable. Recovery may be time-consuming or not possible, impacting your lab access and training progress.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>By clicking Accept, you agree to these terms and take full ownership of your activities on the lab server. Your actions are monitored, and violations may result in access suspension or permanent removal.</TableCell>
              </TableRow>
              <TableCell>
                  <a 
                    href={`${process.env.REACT_APP_GUDELINE_URL}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    🔗 More details
                </a>
                </TableCell>
            </TableBody>
          </Table>
        </DialogContentText>
      </DialogContent>
  
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          ACCEPT
        </Button>
      </DialogActions>
    </Dialog>
    );
  }
